import * as R from 'ramda';

import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from '../../styles/detail-header.module.css';

interface Props {
  form: any;
  isPublished: boolean;
  instanceCount: number;
  preview: boolean;
  savingFormInstance: boolean;
}

const FormInstanceHeader = ({
  form,
  preview,
  savingFormInstance,
  isPublished,
  instanceCount,
}: Props) => {
  const [, { backDestination, navigate }] = useNavigation();

  const navigateBack = () => {
    const backTarget = preview
      ? '/form-repository'
      : !R.isNil(form.workOrderId)
        ? `/workOrders/${form.workOrderId}?view=TASKS`
        : '/workOrders';
    navigate(backDestination(backTarget));
  };

  const navigateToFormBuilder = () => {
    const { id } = form;
    navigate(`/form-builder/${id}`);
  };

  const getRightButtons = (savingText: string) => {
    if (isPublished) {
      return (
        <div className={classes.formBuilderHeader}>
          <div className={classes.inUseText}>{`In Use: ${instanceCount}`}</div>
          <div className={classes.publishedBlock}>
            <Icon color={colors.neutral.white}>lock</Icon>
            <div className={classes.publishedText}>published</div>
          </div>
        </div>
      );
    }

    if (preview && !isPublished) {
      return (
        <div className={classes.formBuilderHeader}>
          <div
            className={classes.backToEditButton}
            onClick={(): void => navigateToFormBuilder()}
          >
            back to edit
          </div>
        </div>
      );
    }

    return <div className={classes.savingText}>{savingText}</div>;
  };

  const savingText = savingFormInstance ? 'Saving ...' : 'All changes saved.';

  const rightButtons = getRightButtons(savingText);

  const hasLeftBackButton = !preview || isPublished;

  const leftButtons = hasLeftBackButton ? (
    <IconButton onClick={navigateBack} tooltip="Go back">
      <Icon color={colors.neutral.white}>arrow_back</Icon>
    </IconButton>
  ) : (
    <div />
  );

  return (
    <div className={classes.previewHeaderContainer}>
      <div className={classes.previewNameContainer}>
        {leftButtons}
        <Icon color={colors.neutral.white}>library_books</Icon>
        <div className={classes.previewNameText}>{form.name}</div>
      </div>
      <div className={classes.actionIconContainer}>{rightButtons}</div>
    </div>
  );
};

export default FormInstanceHeader;
